import React from 'react';
import { Input, Form } from 'antd';
import { StyledButtonLogin } from 'components/styledComponents/button/Button.styled';
import { FormInputWrapper } from 'components/styledComponents/input/Input.styled';
import { AppConstants } from 'constants/index';
import {
  StyledFlexCorrect, StyledFlexEnd, StyledForgetLink, StyledTitleForm,
} from 'app/auth/components/Login.styled';
import { FormItemMarginWrapper } from 'shared/Common.styled';
import { FormItemErrorMessage } from 'shared/formControl';
import { HandleSubmitType } from './Login';

interface LoginStep1Props {
    handleSubmit: HandleSubmitType;
}

const LoginStep1 = ({ handleSubmit }: LoginStep1Props) => (
  <>
    <StyledTitleForm>Log in</StyledTitleForm>
    <FormItemMarginWrapper>
      <FormInputWrapper>
        <Form.Item
          label="Email"
          name="userName"
          rules={[
            {
              required: true,
              message: <FormItemErrorMessage errorMassage="Email cannot be empty!" />,
            },
            {
              pattern: new RegExp(AppConstants.regex.email),
              message: <FormItemErrorMessage errorMassage="The input is not a valid Email!" />,
            },
          ]}
        >
          <Input placeholder="Email" allowClear autoFocus />
        </Form.Item>
      </FormInputWrapper>
    </FormItemMarginWrapper>
    <FormInputWrapper>
      <Form.Item
        label="Password"
        name="password"
        rules={[
          {
            required: true,
            message: <FormItemErrorMessage errorMassage="Password cannot be empty!" />,
          },
        ]}
      >
        <Input.Password type="password" placeholder="Password" />
      </Form.Item>
    </FormInputWrapper>
    <StyledFlexEnd>
      <StyledForgetLink to="/forgotPassword">Recover Password?</StyledForgetLink>
    </StyledFlexEnd>
    <StyledFlexCorrect>
      <StyledButtonLogin size="large" type="primary" htmlType="submit" onClick={handleSubmit} $isMaxWidth>
        LOG IN
      </StyledButtonLogin>
    </StyledFlexCorrect>
  </>
);

export default LoginStep1;
